export default __webpack_public_path__ + "static/media/1007.b0981293.png";